/* NapTap — correctif Add to Cart
 * Le bouton de la barre collante (.nt-sticky-atc) utilisait
 * dispatchEvent(new Event('submit')), ce qui ne soumet PAS un formulaire :
 * les navigateurs ignorent les evenements submit synthetiques.
 * Ce script rebranche le bouton principal ET le bouton collant sur un
 * ajout au panier AJAX via /cart/add.js, avec gestion d'erreur.
 */
(function () {
  function stickyButton() {
    return document.querySelector('.nt-sticky-atc__inner .nt-btn');
  }

  function init() {
    var form = document.getElementById('nt-atc-form');
    if (!form) return;

    var mainBtn = document.getElementById('nt-atc-btn');
    var busy = false;

    function addToCart(evt) {
      if (evt) evt.preventDefault();
      if (busy) return;

      var idField = document.getElementById('nt-variant-id');
      var qtyField = document.getElementById('nt-qty-hidden');
      if (!idField || !idField.value) return;

      var id = Number(idField.value);
      var qty = parseInt(qtyField && qtyField.value, 10) || 1;
      var sticky = stickyButton();
      var label = mainBtn ? mainBtn.textContent : '';

      busy = true;
      if (mainBtn) { mainBtn.disabled = true; mainBtn.textContent = 'Adding...'; }
      if (sticky) sticky.disabled = true;

      function restore() {
        busy = false;
        if (mainBtn) { mainBtn.disabled = false; mainBtn.textContent = label; }
        if (sticky) sticky.disabled = false;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) {
              throw new Error(data.description || data.message || 'Could not add to cart.');
            }
            return data;
          });
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          restore();
          alert(err && err.message ? err.message : 'Could not add to cart.');
        });
    }

    form.addEventListener('submit', addToCart);

    var sticky = stickyButton();
    if (sticky) {
      sticky.removeAttribute('onclick');
      sticky.setAttribute('type', 'button');
      sticky.addEventListener('click', addToCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
